import apiClient from './client';
import type {
  SessionProgram,
  SessionProgramCreateRequest,
  SessionProgramUpdateRequest,
} from '@business-game/shared';

export const sessionProgramsApi = {
  async getAllPrograms(activeOnly = false): Promise<SessionProgram[]> {
    const response = await apiClient.get('/session-programs', {
      params: { active: activeOnly },
    });
    return response.data.data;
  },

  async getProgramById(id: number): Promise<SessionProgram> {
    const response = await apiClient.get(`/session-programs/${id}`);
    return response.data.data;
  },

  async createProgram(data: SessionProgramCreateRequest): Promise<SessionProgram> {
    const response = await apiClient.post('/session-programs', data);
    return response.data.data;
  },

  async updateProgram(id: number, data: SessionProgramUpdateRequest): Promise<SessionProgram> {
    const response = await apiClient.put(`/session-programs/${id}`, data);
    return response.data.data;
  },

  async deleteProgram(id: number): Promise<void> {
    await apiClient.delete(`/session-programs/${id}`);
  },
};
